export default {
  title_one: 'Eliminare {{count}} modificatori?',
  title_other: 'Eliminare {{count}} modificatori?',
  description: '<strong>{{items}}</strong> verrà rimosso dal menu',
  buttons: {
    yes: 'Sì',
    no: 'No',
  },
  toasts: {
    failed_to_delete_modifier_one: 'Eliminazione modificatore fallita',
    failed_to_delete_modifier_other: 'Eliminazione modificatori fallita',
    modifiers_got_deleted_one: 'Modificatore eliminato',
    modifiers_got_deleted_other: 'Modificatori eliminati',
  },
};
